module.exports = __webpack_public_path__ + "07c67a0e858e52ddec50f8419afe66fa.png";